import Tooltip from "PFComponents/tooltip/tooltip";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./time_to_action.module.scss";

type TimeToActionProps = {
  role: {
    time_to_shortlist: number;
    time_to_accept: string;
    time_to_fill: number;
  };
};

const TimeToAction = ({ role }: TimeToActionProps): JSX.Element => {
  const { t } = useTranslation("insights");

  const formatData = (data) => {
    if (data === "NA") {
      return 0;
    } else {
      return data;
    }
  };

  const calculatePercentage = (data, total) => {
    if (total === 0) {
      return 33;
    } else {
      // minimum of 10% for each and 70% for all
      return 10 + (data * 70) / total;
    }
  };

  const { time_to_accept, time_to_shortlist, time_to_fill } = role;
  const timeToAccept = formatData(time_to_accept);
  const timeToShortlist = formatData(time_to_shortlist);
  const timeToFill = formatData(time_to_fill);

  const total = timeToAccept + timeToFill + timeToShortlist;

  const widthTTS = calculatePercentage(timeToShortlist, total);
  const widthTTA = calculatePercentage(timeToAccept, total);
  const widthTTF = calculatePercentage(timeToFill, total);

  const TooltipContent = (
    <div>
      <div>{`${t("timeToShortlist")}: ${time_to_shortlist}`}</div>
      <div>{`${t("timeToAccept")}: ${time_to_accept}`}</div>
      <div>{`${t("timeToFill")}: ${time_to_fill}`}</div>
    </div>
  );

  return (
    <Tooltip content={TooltipContent}>
      <div className={css.wrapper}>
        <div className={css.first} style={{ width: `${widthTTS}%` }} />
        <div className={css.second} style={{ width: `${widthTTA}%` }} />
        <div className={css.third} style={{ width: `${widthTTF}%` }} />
      </div>
    </Tooltip>
  );
};

TimeToAction.propTypes = {
  role: PropTypes.shape({
    time_to_shortlist: PropTypes.number,
    time_to_accept: PropTypes.string,
    time_to_fill: PropTypes.number
  })
};

export default TimeToAction;
